import { useCallback, useEffect, useState } from 'react';

/**
 * How far below the viewport a lazily loaded vignette starts loading, so its
 * chunk is there by the time it scrolls in.
 */
export const PRELOAD_MARGIN = '0px 0px 600px 0px';

/**
 * Whether the element (a callback ref) is on screen or within `margin` of it
 * (PRELOAD_MARGIN below the viewport by default); true for good once it has
 * been. True at once where nothing can observe. Returns `[ref, near]`.
 */
export default function useNearViewport(margin = PRELOAD_MARGIN) {
    const [node, setNode] = useState(null);
    const [near, setNear] = useState(false);

    useEffect(() => {
        if (near || !node) return undefined;
        if (typeof IntersectionObserver === 'undefined') {
            setNear(true);
            return undefined;
        }
        const observer = new IntersectionObserver((entries) => {
            if (entries.some((entry) => entry.isIntersecting)) setNear(true);
        }, { rootMargin: margin });
        observer.observe(node);

        return () => observer.disconnect();
    }, [node, near, margin]);

    return [useCallback((element) => setNode(element), []), near];
}
